export const user = [
  {
    path: '/user',
    name: 'user-info',
    component: () =>
      import(/* webpackChunkName: "user-info" */ '@/views/user/UpdateInfo.vue')
  }
]
